webpackJsonp([20],{

/***/ 1050:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_failedPayment_vue__ = __webpack_require__(1103);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_881b37ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_failedPayment_vue__ = __webpack_require__(1173);
function injectStyle (ssrContext) {
  __webpack_require__(1171)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_failedPayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_881b37ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_failedPayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Offers",

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["default"]
  },
  data: function data() {
    return {
      reserveId: "",
      token: "",
      failedMsg: ""
    };
  },
  mounted: function mounted() {
    this.failedMsg = this.$route.query.resultIndicator;
    this.reserveId = this.$route.params.reserveId;
    this.token = this.$route.params.token;
    // this.getBookingDetails();
  },

  methods: {
    getBookingDetails: function getBookingDetails() {
      var _this = this;

      var payload = {
        Re: this.reserveId,
        token: this.token
      };

      Object(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__["makeRequest"])("/ConfirmBooking", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        if (!error && res.data.Status) {
          console.log("res.data :", res.data);
          window.location.pathname = "/confirmBooking" + _this.reserveId + "/" + _this.token;
        } else {
          window.location.pathname = "/failedPayment";
          console.log("error from res", res.message);
        }
      }).catch(function (error) {
        window.location.pathname = "/failedPayment";
        console.log("Error on vue front", error);
      });
    }
  }
});

/***/ }),

/***/ 1171:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1172);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1036)("dfd55488", content, true, {});

/***/ }),

/***/ 1172:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1035)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"failedPayment.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center error-container"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"faipay-fs"},[_vm._v("\n      "+_vm._s(_vm.failedMsg ? _vm.failedMsg : "Your Payment Failed")+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-4"},[_c('router-link',{staticClass:"retry-btn",attrs:{"to":"/"}},[_vm._v("RETRY")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/20.3edf610dbd6640aebd3b.js